import React, { Component } from "react";
import DocumentoInvalidoComponent from "../../../components/personaReferencia/documentoInvalido/DocumentoInvalidoComponent";
import ModalFrame from "../../../../toolkit/modalFrame";

interface Props {
  storage: string;
  resolucion: boolean;
  razonamiento: string;
  nombre: string;
  isOpen: boolean;
  onClose: () => void;
}

interface State {}

export default class DocumentoInvalidoModal extends Component<Props, State> {
  state = {};

  render() {
    return (
      <ModalFrame
        title="Documento Inválido"
        isOpen={this.props.isOpen}
        toggle={this.props.onClose}
        size="xl"
      >
        <DocumentoInvalidoComponent
          storage={this.props.storage}
          resolucion={this.props.resolucion}
          razonamiento={this.props.razonamiento}
          nombre={this.props.nombre}
          onClose={this.props.onClose}
        />
      </ModalFrame>
    );
  }
}
